export default "__VITE_ASSET__CA82rj9y__"